<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
//margin-bottom: 40px;
}

.demonstration {
  margin-right: 15px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}
</style>
<template>
  <div>
    <detailsData
        v-if="showDetails"
        :poiId="poiId"
        :timeSet="timeSet"
        @closeDetails="closeDetails"
        :value4="value4"
    />
    <div style class="carWrap" v-else>
      <!--   导出省市县参数需联调   -->
      <dimension-dialog
          v-if="showExport"
          @hideExport="hideExport1"
          :moduleName="moduleName"
          :params="params"
          :autoChunkMonth="true"
          :provinceName="formData.provinceName"
          :cityName="formData.cityName"
      />
      <div class="header">
        <el-form :inline="true" :model="formData" label-width="80px">
          <dimension-popover
              ref="objDimensionPopover"
              :isMapValue="true"
              :dimObj="dimObj"
              :change="changeDimension"
              :showBottomButton="false"
              :isItemBindClick="true"
          />
          <el-form-item label="省市区" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-cascader
                v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                collapse-tags
                filterable
                :before-filter="filterMethod"
                clearable></el-cascader>
          </el-form-item>
          <el-form-item label="吨位区间" label-width="75px">
            <el-select v-model="formData.dunwei" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in dunWeiOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="省份：">-->
          <!--            <el-select-->
          <!--              v-model="formData.provinceName"-->
          <!--              placeholder="请选择活动区域"-->
          <!--              @change="getCityList"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                v-if="areaList.length > 1"-->
          <!--                label="全部"-->
          <!--                value-->
          <!--              ></el-option>-->
          <!--              <el-option-->
          <!--                v-for="(item, index) in areaList"-->
          <!--                :label="item.provinceName"-->
          <!--                :value="item.provinceCode"-->
          <!--                :key="index"-->
          <!--              ></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="地区：">-->
          <!--            <el-select-->
          <!--              v-model="formData.cityName"-->
          <!--              placeholder="请选择活动区域"-->
          <!--              @change="getCityName"-->
          <!--            >-->
          <!--              <el-option label="全部" value></el-option>-->
          <!--              <el-option-->
          <!--                v-for="(item, index) in cityData"-->
          <!--                :label="item.cityName"-->
          <!--                :value="item.cityCode"-->
          <!--                :key="index"-->
          <!--              ></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-button @click="submitData">查询</el-button>
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
          <el-button
              v-show="hideExport"
              style="margin-left:15px;"
              @click="exportDate"
          >导出全部明细
          </el-button
          >
        </el-form>
      </div>
      <main>
        <Table :allData="allData" :index="indexAll" @tableShow="submitData2"/>
      </main>
      <div
          class="block"
          style="width: fit-content; margin-left: auto; margin-right: auto;"
      >
        <el-pagination
            style="text-align:center;padding-top:10px;padding-bottom:10px;"
            @current-change="changeData"
            :current-page.sync="index"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
            slot="pagin"
        ></el-pagination>
      </div>

    </div>
    <div v-if="!showDetails" class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png"/>
        <span>说明</span>
      </h4>
      <div>
        1.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。
      </div>
      <div>
        2.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。
      </div>
      <div>
        3.停靠次数：统计不同燃料类型车辆在该物流园的停靠次数。一辆车在同个物流园一天停靠多次，计为多次。
      </div>
      <div>
        4.统计频率：按月统计，每月6日更新上月数据。
      </div>
      <div>
        5.下一级页面：点击具体物流园名称，进入“物流园停靠次数TOP100企业情况”页面。
        【注】如您发现某个物流园相关信息需要更新，请联系省级管理员或中交兴路顾问。
      </div>
    </div>
  </div>
</template>
<script>
import Table from './components/table' // 表格数据
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
import exportDate from '@/components/exportDate'
import {hideExport, mergeTree} from '@/utils/tools'
import Util from '@/utils/util'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import detailsData from './components/details.vue'
import get from 'lodash/get'
import set from 'lodash/set'
import each from 'lodash/each'
import {exportTruckSimplify, progress} from "api/log";

var now = new Date()
now.setMonth(now.getMonth() + 1)
export default {
  components: {
    dimensionDialog,
    Table,
    exportDate,
    dimensionPopover,
    detailsData
  },
  data() {
    let value4 = Util.lastTime(new Date())
    let month = ''
    let arr = value4.split('-')
    let dimObj = {
      year: arr[0],
      month: arr[1],
      type: '0'
    }
    console.log(dimObj, "diaobj")
    return {
      params: {},
      dimObj,//纬度对像
      hideExport: hideExport,
      moduleName: 'wuliuCollectionStatV2',
      showExport: false, //控制批量导出
      areaListPr: [],
      dunWeiOption: Util.dunWeiOption,
      formData: {
        provinceName: '',
        cityName: '',
        dunwei: [],// 需联调
        provCityCounty: [], // 需联调
      },
      provinceName: '',
      cityName: '',
      areaList: [],
      cityData: [],
      monTime: now, // 默认月份
      // mark: false, // 遮罩层
      // progressNum: 0, // 导出下载进度条
      total: 0, // 总页数
      allData: [], // 总数据
      index: 1, // 当前页数
      endMonth: '', //请求日期
      pageSize: 20,
      timeSet: '',
      indexAll: 0,
      showDetails: false,
      value4,
      poiId: '' //物流园id
    }
  },
  mounted() {
    let that = this
    let time = that.monTime
    let year = time.getFullYear()
    let month = time.getMonth()
    that.endMonth = year + that.initMonth(month)
    this.getPrInter()
    // this.moren()
    this.initData(3)
    // this.getProvinces()
  },
  methods: {
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)

      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      let dateType = get(this, 'dimObj.type', '0')
      let params = {
        dateType,
        year: this.dimObj.year,
        month: this.dimObj.month,
        tonnages: this.formData.dunwei,
        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes,
      }
      window.location.assign(
          exportTruckSimplify({
            reqId,
            ...params
          })
      )
    },
    propsData() {
      const vm = this
      return {
        lazy: false,
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    async getPrInter() {
      http
          .getCountyAreaListBySearch({keyword: ''})
          .then(({data}) => {
            this.areaListPr = data
          })
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    async moren() {
      var that = this
      let year = this.value4.split("-")[0]
      let month = this.value4.split("-")[0]
      let moduleName = this.moduleName
      let params = {
        moduleName,
        year,
        provinceCode: '',
        provinceName: '',
        region: '',
        brand: '',
        pathwayCityCode: '',
        roadCode: ''
      }
      let {data} = await http.carLogiDetalMonth(params)
      let dataMon = data.reverse()
      for (let it of dataMon) {
        if (it.includes('ok')) {
          month = it.substring(0, 2)
          that.dimObj.month = month
          that.$refs.objDimensionPopover.setCtrlValue()
          that.initData()
          return
        }
      }
    },
    changeDimension(e) {
      if (e.isOk) {
        let type = e.type
        let arr = get(this, ['dimsTitle', type], [])
        each(arr, (title, index) => {
          if (title) {
            set(this, ['titleArr', index, 'title'], title)
          }
        })
        this.value4 = e.year + '-' + e.month
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = type
        // this.changeTime()
      }
    },
    async getProvinces() {
      let that = this
      let {data} = await http.getProvinces()
      that.areaList = [...data]
      if (that.areaList.length == 1) {
        that.formData.provinceName = that.areaList[0].provinceCode
        that.getCityList(that.areaList[0].provinceCode)
      }
    },
    closeDetails() {
      this.formData = {
        provinceName: '',
        cityName: '',
        dunwei: [],// 需联调
        provCityCounty: [], // 需联调
      }
      this.showDetails = false
      this.initData()
    },
    async getCityList(e) {
      let that = this
      let provname = that.getProvienceName(e)
      if (e) {
        let {data} = await http.getCityList({provname})
        that.cityData = [...data]
      } else {
        this.provinceName = ''
        this.cityData = []
      }
    },
    getCityName(e) {
      this.cityName = e
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    changeData(index) {
      let that = this
      that.index = index
      this.initData(1)
      that.indexAll = that.pageSize * (that.index - 1)
    },
    submitData() {
      this.index = 1
      this.indexAll = 0
      this.initData(1)
    },
    submitData2(row) {
      this.showDetails = true
      this.poiId = row.poiId
      this.timeSet = this.dimObj.year + '-' + this.dimObj.month
    },
    filterMethod(value) {
      return http
          .getCountyAreaListBySearch({keyword: value})
          .then(({data}) => {
            if (data.length !== 0) {
              const oldList = this.areaListPr || []
              const newList = data || []
              this.areaListPr = mergeTree(oldList, newList)
              return true // 允许 filter
            }
            return false // 阻止 filter
          })
    },
    getProvienceName(citycode) {
      for (var k in this.areaList) {
        if (citycode === this.areaList[k].provinceCode) {
          return this.areaList[k].provinceName
        }
      }
    },
    async initData(num = 0) {
      let dateType = get(this, 'dimObj.type', '0')
      let that = this

      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      let params = {
        dateType,
        pageNum: that.index,
        pageSize: that.pageSize,
        // countTime,
        // firstIs: num,
        // 原省市-需联调
        // provinceCode: that.formData.provinceName,
        // cityCode: that.formData.cityName
        //
        year: num == 3 ? '' : this.dimObj.year,
        month: num == 3 ? '' : this.dimObj.month,
        tonnages: this.formData.dunwei,
        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes,
      }
      let {data} = await http.truckWuliuV2(params)
      console.log(data)
      if (data && data.dataList) {
        that.allData = [...data.dataList]
        that.total = data.total
        // that.monTime = data.time
        // that.endMonth = data.time.replace('-', '')
        // this.dimObj = {
        //   year: data.year,
        //   month: data.month,
        //   type: '0'
        // }
        this.dimObj.year = data.year
        this.dimObj.month = data.month
        that.$refs.objDimensionPopover.setCtrlValue()
        that.index = data.pageNum
        that.pageSize = data.pageSize
        console.log(data, 'data')
      } else {
        that.allData = []
      }
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.endMonth = arr[0] + '' + arr[1]
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    exportDate() {
      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      this.params = {
        pageNum: this.index,
        pageSize: this.pageSize,
        year: this.dimObj.year,
        month: this.dimObj.month,
        tonnages: this.formData.dunwei,
        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes,
      }
      this.showExport = true
      return
    }
  }
}
</script>
